import { Props } from 'docz';
import { Playground } from '@playground';
import { Flex } from "../../../../../packages/core/src/components/globals/globals";
import * as React from 'react';
export default {
  Props,
  Playground,
  Flex,
  React
};